import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
  createRefund,
  getRefundDetail,
  sendWhatsapp
} from "@/store/refund-detail/action";

const initialState = {
  state: {
    refund: null,
    modal: {
      show: false,
      currentId: null
    }
  },
  loading: false,
  error: ''
} as BaseState<RefundDetailState>

const slice = createSlice({
  name: 'refundDetailSlice',
  initialState,
  reducers: {
    resetRefundDetail: () => ({ ...initialState }),
    showRefundDetailModal : (state, { payload }: PayloadAction<RefundDetailModalPayload>) => {
      if (payload.show) {
        document.getElementById('root').style.overflow = 'hidden'
      } else {
        document.getElementById('root').style.overflow = 'auto'
      }
      return {
        ...state,
        state: {
          ...state.state,
          modal: {
            show: payload.show,
            currentId: payload.id
          }
        }
      }
    }
  },
  extraReducers: (builder) => {
    // get detail
    builder.addCase(getRefundDetail.fulfilled, (state, action) => ({
      ...state,
      state: {
        ...state.state,
        refund: action.payload
      },
      error: '',
      loading: false
    }))
    builder.addCase(getRefundDetail.rejected, (state) => ({
        ...state,
        error: 'Failed to get refund detail data',
        loading: false
      }
    ))
    builder.addCase(getRefundDetail.pending, (state) => ({
        ...state,
        loading: true
      }
    ))
    // create refund
    builder.addCase(createRefund.fulfilled, (state) => ({
      ...state,
      error: '',
      loading: false
    }))
    builder.addCase(createRefund.rejected, (state) => ({
        ...state,
        error: 'Failed to get create refund',
        loading: false
      }
    ))
    builder.addCase(createRefund.pending, (state) => ({
        ...state,
        loading: true
      }
    ))
    // send whatsapp
    builder.addCase(sendWhatsapp.fulfilled, (state) => ({
      ...state,
      error: '',
      loading: false
    }))
    builder.addCase(sendWhatsapp.rejected, (state) => ({
        ...state,
        error: 'Failed to send whatsapp',
        loading: false
      }
    ))
    builder.addCase(sendWhatsapp.pending, (state) => ({
        ...state,
        loading: true
      }
    ))
  }
})

export default slice
export const refundDetailActions = slice.actions
